import React from "react";
import {
  Box,
  Typography,
  Stack,
  Card,
  CardContent,
  Avatar,
  Chip,
  IconButton,
} from "@mui/material";
import {
  Edit as EditIcon,
  AddAPhoto as AddPhotoIcon,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { RoleString, uploadUserAvatar } from "../../../../../data/UserData";
import NewColors from "../../../../../themes/NewColors";

const HeaderCard = styled(Card)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(2),
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  marginBottom: theme.spacing(3),
}));

const StatusChip = styled(Chip)(({ theme, status }) => ({
  backgroundColor:
    status === "active"
      ? theme.palette.success.main
      : theme.palette.warning.main,
  color: NewColors.white,
  fontWeight: "bold",
}));

const AvatarWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
  display: "inline-block",
  marginRight: theme.spacing(3),
}));

const PhotoIconButton = styled(Box)(({ theme }) => ({
  position: "absolute",
  bottom: 0,
  right: 0,
  zIndex: 2,
  borderRadius: "50%",
  height: 40,
  width: 40,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  boxShadow: theme.shadows[2],
}));

const CoachHeader = ({ coach, onEditClick, onAvatarUpdate }) => {
  // Defensive check to ensure coach is properly loaded
  if (!coach) {
    return null;
  }

  const handleChangeAvatar = async (e) => {
    if (e.target.files[0]) {
      const image = e.target.files[0];
      await uploadUserAvatar({
        uid: coach.uid,
        file: image,
        progressFunction: () => {
          //
        },
      });

      if (onAvatarUpdate) {
        onAvatarUpdate();
      }
    }
  };

  // Using disableFocusRipple and disableRipple to avoid MUI's focus tracking issues
  return (
    <>
      <HeaderCard className="coach-summary-card fade-in-animation">
        <CardContent>
          <Box sx={{ display: "flex", alignItems: "flex-start" }}>
            <AvatarWrapper className="coach-avatar-wrapper">
              <Avatar
                src={`${coach.avatarUrl}`}
                sx={{ width: 120, height: 120 }}
              />
              <PhotoIconButton className="coach-photo-button">
                <label style={{ display: "flex", cursor: "pointer" }}>
                  <AddPhotoIcon color="primary" />
                  <input
                    hidden
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    onChange={handleChangeAvatar}
                  />
                </label>
              </PhotoIconButton>
            </AvatarWrapper>

            <Box sx={{ flexGrow: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 1,
                }}
              >
                <Typography variant="h5" component="h1" fontWeight="bold">
                  {`${coach.firstName} ${coach.lastName}`}
                </Typography>
                <Box>
                  <StatusChip
                    size="small"
                    status={coach.active !== false ? "active" : "inactive"}
                    label={coach.active !== false ? "Active" : "Inactive"}
                  />
                  {/* Removed Tooltip and disabled ripple to fix addEventListener issue */}
                  <IconButton
                    onClick={onEditClick}
                    size="small"
                    sx={{ ml: 1 }}
                    aria-label="Edit Coach"
                    disableRipple
                    disableFocusRipple
                  >
                    <EditIcon />
                  </IconButton>
                </Box>
              </Box>

              <Stack spacing={1}>
                <Typography variant="body1">
                  <strong>Email:</strong> {coach.email || "Not provided"}
                </Typography>
                <Typography variant="body1">
                  <strong>Role:</strong> {RoleString[coach.role] || "Unknown"}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  <strong>UID:</strong> {coach.uid || "none"}
                </Typography>
              </Stack>
            </Box>
          </Box>
        </CardContent>
      </HeaderCard>
    </>
  );
};

export default CoachHeader;
